import { store, type RootState } from '@/redux-store';
import { routeManager } from '../route';
import type { RouteManagerInterface } from '../route/routeManager';
import { RoleTypeManager } from './roleTypeManager';

const roleTypeManager = (routeManager: RouteManagerInterface) =>
    new RoleTypeManager(routeManager);

export const getRoleType = () => {
    const { auth: user } = store.getState() as RootState;

    if (!user.userInformation || !user.userInformation.clientRole) {
        return null;
    }

    const roleType = roleTypeManager(routeManager).create(
        user.userInformation.clientRole
    );

    return roleType;
};
